import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Typography } from '@material-ui/core'
import StyledNumberField from '../../../pages/PlayersPage/components/StyledNumberField'
import gameResultSectionStyles from './gameResultSection.styles'

const useStyles = makeStyles(gameResultSectionStyles)

// Values are kept as strings so an empty field stays distinguishable from 0.
const ScorePairInputs = ({ homeTeam, awayTeam, values, onChange, disabled }) => {
  const classes = useStyles()

  const cell = (team) => (
    <div className={classes.scoreCell} key={team.id}>
      <Typography className={classes.teamLabel}>{team.name}</Typography>
      <StyledNumberField
        className={classes.scoreField}
        label=''
        value={values[team.id] ?? ''}
        onChange={(e) => onChange({ ...values, [team.id]: e.target.value })}
        min={0}
        step={1}
        disabled={disabled}
        inputProps={{ 'aria-label': team.name }}
      />
    </div>
  )

  return (
    <div className={classes.scoreRow}>
      {cell(homeTeam)}
      {cell(awayTeam)}
    </div>
  )
}

const teamShape = PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })

ScorePairInputs.propTypes = {
  homeTeam: teamShape.isRequired,
  awayTeam: teamShape.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default ScorePairInputs
